<template>
  <div class="ComplexSaleDetailViewContainer" v-if="detail">
    <!--    <CountDownHeader style="position: absolute;top: 0" :free-head-count="order.freeHeadCount" :timeout="resetTime"/>-->
    <!--主图-->
    <img :src="detail.coverImage" style="width: 100%"/>
    <nut-row class="bothCenter opd16 vpd6 box"
             style="background:rgba(0,0,0,0.4);margin-top: -42px">
      <nut-col :span="12" class="leftCenter">
        <AvatarRow :limit="5" :avatars="detail.buyerAvatars"/>
      </nut-col>
      <nut-col :span="12" class="rightCenter ft14 wft">
        <span>已有</span>
        <span class="numberText">{{ detail ? detail.fakeBuyerCnt + detail.realBuyerCnt : '-' }}</span>
        <span>人报名课程</span>
      </nut-col>
    </nut-row>
    <nut-tabs v-model="tab" type="smile" color="#EF773B" :auto-height="true" background="white">
      <template v-for="(ipt,iptIndex) in detail.introduceParts" :key="`introduceParts${iptIndex}`">
        <nut-tabpane :title="ipt.partName" style="background: transparent;padding:0 0 200px 0" :pane-key="iptIndex">
          <template v-for="p in ipt.contents" :key="`pppp_${p.id}`">
            <template v-if="p.contentType =='VIDEO'">
              <div class="colFlex bothCenter" style="position:relative;" @click="playVideo(p.content)">
                <img :src="`${p.content}?x-oss-process=video/snapshot,t_5000`"
                     @click="playVideo(p.content)"
                     style="width: 100%" class="wd100"/>
                <img src="https://cdn.waityou.online/19d94b56-8c5e-6a6c-0e5a-a5156332e4dd.svg"
                     class="sqr80 wbg brd80"
                     @click="playVideo(p.content)"
                     style="position: absolute;top: calc(50% - 40px);left: calc(50% - 40px)">
              </div>
            </template>
            <img :src="p.content" style="padding: 0;vertical-align: middle;"
                 class="wd100 mt8" v-if="p.contentType =='IMG'"/>
            <div class="opd8" style="margin: 0" v-if="p.contentType =='TEXT'" v-html="p.content"></div>
          </template>

        </nut-tabpane>
      </template>
      <nut-tabpane title="订单列表" style="background: transparent;padding:0 0 200px 0" pane-key="99">
        <BuyerList :orders="horse"/>
      </nut-tabpane>
    </nut-tabs>

    <nut-row class="wd100 wbg" style="position:fixed;bottom: 0;padding-bottom: 12px">
      <div style="background: #FCE4D8;width: 100%" class="vpd4 bothCenter">
        <nut-countdown v-model="resetTime" millisecond :endTime="end">
          <nut-row class="bothCenter">
            <img src="https://cdn.waityou.online/9539ab0c-fbb4-e080-ba7b-272052328e77.svg" class="sqr16">
            <span class="ft12 ">&nbsp;优惠提醒：您有</span>
            <span class="ft12 numberText">{{order.discount}}元优惠券</span>
            <span class="ft12">,即将失效</span>
            <div style="width: 60px" class="bothCenter ft12 numberText">
              {{ resetTime.m.toString().padStart(2, '0') }}:{{
                resetTime.s.toString().padStart(2, '0')
              }}:{{ resetTime.ms }}
            </div>
          </nut-row>
        </nut-countdown>
      </div>
      <nut-row class="bothCenter pd16 box">
        <nut-col :span="16" class="leftCenter numberText" v-if="showAfterCouponPrice">
          <span class="ft20">限时</span>
          <span class="ft16 ml8">¥</span>
          <span class="ft30 ml2">{{ (order.originalPrice - order.discount).toFixed(2) }}</span>
          <div class="colFlex ml4">
            <span class="ft10" style="text-decoration:line-through">原价¥{{ order.originalPrice }}</span>
            <span class="ft10 opd2 wft" style="background: #EF773B">已优惠¥{{ order.discount }}</span>
          </div>
        </nut-col>
        <nut-col :span="16" class="leftCenter numberText" v-if="!showAfterCouponPrice">
          <span class="ft16 ml8">¥</span>
          <span class="ft30 ml2">{{ order.originalPrice }}</span>
        </nut-col>
        <nut-col :span="8" class="rightCenter">
          <button class="wft ft18 buyBtn vpd8 opd12 brd20" @click="buyNow">立即报名</button>
        </nut-col>
      </nut-row>
      <nut-row class="ft12 bothCenter">
        <nut-checkbox icon-size="12" v-model="agree"/>
        <span>我已阅读并同意</span>
        <a :href="detail.privateInfoProtectAgreement" style="text-decoration: none">
          <span class="numberText">《个人信息授权与保护声明》</span>
        </a>
      </nut-row>
    </nut-row>

    <nut-overlay v-model:visible="couponVisible" class="bothCenter" :close-on-click-overlay="false">
      <RedCouponPopover v-if="couponVisible && couponStep == 0" :data="detail"
                        @click="couponStep=1;setCoupon()"/>
      <RedCouponOpenPopover v-if="couponVisible && couponStep == 1"
                            :discount="order.discount" :lesson-name="detail.name"
                            :used-people="detail.fakeBuyerCnt+detail.realBuyerCnt"
                            @click="couponVisible=false;discountVisible=true"/>
    </nut-overlay>

    <nut-popup position="bottom" v-model:visible="discountVisible">
      <DiscountPrice :original-price="order.originalPrice"
                     @buy="buyNow"
                     :discount="order.discount" v-if="discountVisible"/>
    </nut-popup>

    <nut-popup position="bottom" v-model:visible="skuVisible" closeable>
      <SkuSelector :skus="detail.skus" v-if="detail" @buySku="buySku"/>
    </nut-popup>


    <nut-popup v-model:visible="playerVisible" lock-scroll
               style="width: 90vw;background: transparent">
      <video :src="videoUrl" style="margin: 8px 0 0 0;padding: 0;" autoplay="autoplay"
             class="wd100" controls v-if="playerVisible"></video>
    </nut-popup>

    <template v-if="horse.length > 0">
      <swiper
          class="iceLamp"
          :direction="'vertical'"
          :slides-per-view="3"
          :space-between="0"
          :modules="modules"
          :autoplay="{
            delay: 2500,
            disableOnInteraction: false,
          }"
      >

        <template v-for="h in horse" :key="`hourse_${h.id}`">
          <swiper-slide>
            <SaleHorseLamp :data="h"/>
          </swiper-slide>
        </template>
      </swiper>

      <!--      <nut-noticebar-->
      <!--          style="position: fixed;left: 0;top: 20px;border-radius: 20px"-->
      <!--          direction='vertical' :height='25' :speed='15' :standTime='2000' :list="[]"-->
      <!--          :background="`rgba(107,107,107,0.7)`">-->

      <!--      </nut-noticebar>-->
    </template>
  </div>
</template>

<script>

import RedCouponPopover from "@/components/sale/RedCouponPopover";
import RedCouponOpenPopover from "@/components/sale/RedCouponOpenPopover";
import AvatarRow from "@/components/sale/AvatarRow";
import DiscountPrice from "@/components/sale/DiscountPrice";
import BuyerList from "@/components/sale/BuyerList";
import api from "@/api";
import {Toast} from "@nutui/nutui";

import SaleHorseLamp from "@/components/sale/SaleHorseLamp";
import SkuSelector from "@/components/sale/SkuSelector";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, } from 'swiper/modules';

export default {
  name: "ComplexSaleDetailView",
  components: {
    SkuSelector,
    /* eslint-disable */
    SaleHorseLamp,Swiper, SwiperSlide,Autoplay,
    BuyerList, AvatarRow, RedCouponPopover, DiscountPrice, RedCouponOpenPopover
  },
  data() {
    return {
      playerVisible: false,
      videoUrl: null,
      skuVisible: false,
      horse: [],
      modules:[Autoplay],
      resetTime: {
        d: '1',
        h: '00',
        m: '00',
        s: '00',
        SS: '00',
      },
      lampOption: {
        singleHeight: 30,
        direction: 0,
      },
      end: Date.now() + 60 * 1000 * 5,
      discountVisible: false,
      couponVisible: false,
      couponStep: 0,
      tab: 0,
      order: {
        freeHeadCount: 39,
        originalPrice: 99,
        discount: 30,
      },

      timeout: '5分0秒',
      sec: 299,
      ct: null,
      agree: true,
      lessonId: this.$route.params.lessonId,
      detail: null,
      showAfterCouponPrice: false,
    }
  },
  methods: {
    playVideo(url){
      this.videoUrl = url;
      this.playerVisible = true;
    },
    setCoupon() {
      this.showAfterCouponPrice = true;
      localStorage.setItem('lastCouponShow', new Date().getTime())
    },
    canShowCoupon() {
      let lcs = localStorage.getItem('lastCouponShow')
      if (!lcs) {
        return true
      }
      return new Date().getTime() - lcs > 5 * 60 * 1000;
    },
    minSkuPrice(skus) {
      let m = 999999999;
      for (let s of skus) {
        if (s.originalPrice < m) {
          m = s.originalPrice;
        }
      }
      return (m / 100).toFixed(2)
    },
    buyerLimit(skus) {
      let t = 0;
      for (let s of skus) {
        t += s.realBuyerLimit;
      }
      return t;
    },
    init() {
      if (!this.canShowCoupon()) {
        this.showAfterCouponPrice = true;
      }
      api.getSaleGood(this.lessonId)
          .then(ret => {
            this.detail = ret.good;
            this.order.originalPrice = this.minSkuPrice(ret.good.skus);
            this.order.discount = (ret.good.couponPrice / 100).toFixed(2)
            this.order.freeHeadCount = (this.buyerLimit(ret.good.skus) - ret.good.realBuyerCnt) % 50;

            if (ret.good.couponShow && this.canShowCoupon()) {
              setTimeout(() => {
                this.couponVisible = true;
              }, 3000)
            } else {
              this.$emit('showHelp')
            }
          })
      this.updateHoursLamp();
      this.freeMinusTask = setInterval(() => {
        if (Math.random() > 0.5) {
          this.order.freeHeadCount = Math.max(1, this.order.freeHeadCount - 1);
          this.detail.fakeBuyerCnt += this.order.freeHeadCount > 1 ? 1 : 0;
        }
      }, 1000)
      this.ct = setInterval(this.updateHoursLamp, 60000)
    },
    updateHoursLamp() {
      api.getRecentOrderList(this.lessonId)
          .then(ret => {
            this.horse = ret;
          })
    },
    buyNow() {
      if (!this.agree) {
        Toast.warn('请先阅读并同意隐私政策')
        return
      }
      if (this.detail.skus.length > 1) {
        //多sku
        this.skuVisible = true;
      } else {
        this.buySku(this.detail.skus[0])
      }
    },
    buySku(sku) {
      this.$router.push(`/sale/create/${this.lessonId}/${sku.id}`)
      // Toast.loading('正在发起支付...')
      // let host = window.location.protocol + '//' + window.location.host
      // console.log('host', host)
      // api.createPayOrder({
      //   goodId: this.lessonId,
      //   skuId: sku.id,
      //   redirect: host + '/sale/lesson/pay/' + this.lessonId,
      // }).then(ret => {
      //   window.location.href = ret;
      // })
    }
  },
  mounted() {
    this.init()
  },
  unmounted() {
    if (this.ct) {
      clearInterval(this.ct)
    }
    if (this.freeMinusTask) {
      clearInterval(this.freeMinusTask)
    }
  }
}
</script>
<style>
.nut-noticebar-vertical {
  border-radius: 20px !important;
  background: transparent !important;
}
</style>
<style lang="scss" scoped>
.ComplexSaleDetailViewContainer {
  display: flex;
  position: relative;
  flex-direction: column;
  background-color: white;
  min-height: 100vh;


  .buyBtn {
    border: none;
    background: linear-gradient(0deg, #E05E1D 0%, #EF773B 100%);
  }
}

.iceLamp {
  position: fixed;
  overflow: hidden;
  height: 100px;
  left: 5px;
  top: 20px;
  z-index: 99;
}
</style>